import { render } from "./PositionsModal.vue?vue&type=template&id=1a9744ee&scoped=true"
import script from "./PositionsModal.vue?vue&type=script&lang=js"
export * from "./PositionsModal.vue?vue&type=script&lang=js"

import "./PositionsModal.vue?vue&type=style&index=0&id=1a9744ee&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9744ee"]])

export default __exports__